import Communication from './Communication';
export default Communication;
